import axios from 'axios'
import Swal from 'sweetalert2'
import { $axios } from '@/modules/http/axios'

const tasksListModule = {
  state: () => ({
    axiosConfig: { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } },
    monthlyTasks: [],
    renderableTasks: [],
    monthlyTasksPage: 0,
    vehicles: [],
    drivers: [],
    places: [],
    delayReports: []
  }),

  getters: {
    getVehicles (state) {
      return state.vehicles
    },

    getDrivers (state) {
      return state.drivers
    },

    getMonthlyTasks (state) {
      return state.monthlyTasks
    },

    getRenderableTasks (state) {
      return state.renderableTasks
    },

    getPlaces (state) {
      return state.places
    },

    getDelayReports (state) {
      return state.delayReports
    }
  },

  mutations: {
    setVehicles (state, vehicles) {
      state.vehicles = vehicles
    },

    setDrivers (state, drivers) {
      state.drivers = drivers
    },

    setMonthlyTasks (state, tasks) {
      tasks.map(task => state.monthlyTasks.push(task))
    },

    appendMonthlyTasksPart (state, perPage) {
      const monthlyTasksPart = state.monthlyTasks.slice(state.monthlyTasksPage * perPage, (state.monthlyTasksPage + 1) * perPage)
      monthlyTasksPart.map(t => state.renderableTasks.push(t))

      state.monthlyTasksPage++
    },

    setPlaces (state, places) {
      state.places = places
    },

    setDelayReports (state, delayReports) {
      state.delayReports = delayReports
    }
  },

  actions: {
    fetchMonthlyTasks ({ commit, state }, dates) {
      if (localStorage.getItem('accessToken')) {
        const axiosConfig = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

        axios.get(`${process.env.VUE_APP_API_BASE_URL}Task/Filtered/Dates?fromDate=${dates.start}&toDate=${dates.end}`, axiosConfig).then(response => {
          commit('setMonthlyTasks', response.data)
        }).catch(e => {
          Swal.fire('Nie udało się pobrać zleceń', '', 'error').then(() => console.log(e))
        })
      }
    },

    fetchVehicles ({ commit, state }) {
      const axiosConfig = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

      axios.get(`${process.env.VUE_APP_API_BASE_URL}Vehicle`, axiosConfig).then(r => {
        commit('setVehicles', r.data)
      }).catch(e => {
        console.log(e)
      })
    },

    fetchDrivers ({ commit, state }) {
      const axiosConfig = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

      axios.get(`${process.env.VUE_APP_API_BASE_URL}Driver`, axiosConfig).then(r => {
        commit('setDrivers', r.data)
      }).catch(e => {
        console.log(e)
      })
    },

    fetchPlaces ({ commit, state }) {
      const axiosConfig = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

      axios.get(`${process.env.VUE_APP_API_BASE_URL}Place`, axiosConfig).then(r => {
        commit('setPlaces', r.data)
      }).catch(e => {
        console.log(e)
      })
    },

    fetchDelayReports ({ commit }) {
      $axios.get('Delay').then(response => {
        commit('setDelayReports', response.data)
      })
    }
  }
}

export default tasksListModule
